import * as React from "react";
import { useState } from "react"; // Step 1: Import useState
import { styled } from "@mui/system";
import Dropdown from "./Dropdown";
import Box from "@mui/material/Box";
import planb from "./data/planb.json";
import bkv_plans from "./data/bkv_plans.json";

const FlexContainer = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "start",
  gap: "28px",
  width: "100%",
  marginLeft: "20px",
  "@media (max-width: 768px)": {
    flexDirection: "column",
    marginLeft: "0px",
  },
});

const PlanContainer = styled("div")({
  "& p": {
    textAlign: "center",
    marginBottom: "8px",
  },
});

const PlanTitle = styled("h1")({
  fontSize: "38px",
  fontWeight: "bold",
});

const kWhValues = {
  kWh500: 24.2,
  kWh1000: 24.2,
  kWh1500: 20.3,
  kWh2000: 20.4,
  kWh2500: 18.7,
};

const prices = {
  Price500: "19.200000",
  Price1000: "18.800000",
  Price2000: "18.500000",
};

// const providerMenuItems1 = Object.keys(kWhValues).map((key) => ({
//   value: key,
//   label: key,
// }));

const uniqueProviders = Object.values(planb.response).reduce(
  (acc, responseArray) => {
    responseArray.forEach((current) => {
      const existingProvider = acc.find(
        (item) => item.provider_name === current.provider_name
      );
      if (!existingProvider) {
        acc.push(current);
      }
    });
    return acc;
  },
  []
);

const providerMenuItems0 = uniqueProviders.map((provider) => ({
  value: provider.provider_id,
  label: provider.provider_name,
}));

const planMenuItems1 = Array.from(
  new Set(
    Object.keys(bkv_plans.plans).flatMap((planKey) =>
      bkv_plans.plans[planKey].map((plan) => plan.Terms)
    )
  )
)
  .sort((a, b) => a - b)
  .map((value) => ({ value, label: `${value} Months` }));

// const planMenuItems1 = bkv_plans.plans.bluebonnet.map((plan) => {
//   return { value: plan.Terms, label: `${plan.Terms} Months` };
// });
const planMenuItems3 = Array.from(
  new Set(
    Object.keys(bkv_plans.plans).flatMap((planKey) =>
      bkv_plans.plans[planKey].map((plan) => plan.Title.slice(0, -2))
    )
  )
).map((title) => ({ value: title, label: title }));

const planMenuItems0 = [{ label: "BKV", value: "bkv", id: 1 }];

const planMenuItems2 = [
  {
    value: "12",
    label: "12 Months",
  },
];

const DefaultPlan = {
  details: "Plan A",
  gimmick: "None",
  energyCharge: "0.08 ¢/kWh",
  rates: {
    "500kWh": "0.08 ¢/kWh",
    "1000kWh": "0.08 ¢/kWh",
    "2000kWh": "0.08 ¢/kWh",
  },
  baseCharge: "None",
  usageFee: "None",
  etf: "$2/mo",
  billCredit: "None",
};

const GraphHeader = ({ setPlan1, setPlan2 }) => {
  const [selectedProvider0, setSelectedProvider0] = useState("");
  const [selectedProvider1, setSelectedProvider1] = useState("");
  const [selectedProvider2, setSelectedProvider2] = useState("");
  const [providerMenuItems2, setProviderMenuItems2] = useState([]);
  const [selectedPlan0, setSelectedPlan0] = useState(planMenuItems0[0].value);
  const [selectedPlan1, setSelectedPlan1] = useState(planMenuItems1[0].value);
  const [selectedPlan2, setSelectedPlan2] = useState(planMenuItems2[0].value);

  // console.log("selectedPlan1", selectedPlan1);
  const handleProvider0Change = (e) => setSelectedProvider0(e.target.value);

  const handleProvider1Change = (e) => {
    setSelectedProvider1(e.target.value);
  };
  const handleProvider2Change = (e) => {
    setSelectedProvider2(e.target.value);
  };
  // const handleProvider2Change = (e) => setSelectedProvider2(e.target.value);
  const handlePlan0Change = (e) => setSelectedPlan0(e.target.value);
  const handlePlan1Change = (e) => setSelectedPlan1(e.target.value);
  const handlePlan2Change = (e) => setSelectedPlan2(e.target.value);

  React.useEffect(() => {
    const getPlanNameByProviderName = (providerName) => {
      if (providerName.length === 0) return [];
      const plans = planb.response[providerName].map((plan) => {
        return {
          value: plan.plan_name,
          label: plan.plan_name,
        };
      });
      // console.log("plans", plans);
      return plans;
    };
    // console.log("selectedProvider0", selectedProvider0);
    setProviderMenuItems2(getPlanNameByProviderName(selectedProvider0));
  }, [selectedProvider0]);

  React.useEffect(() => {
    // Find the plan that matches the selected Terms value
    const planDetails = bkv_plans.plans["bluebonnet"].find(
      (plan) => plan.Terms === selectedPlan1
    );

    if (planDetails) {
      setPlan1({
        ...DefaultPlan,
        details: "Plan A",
        energyCharge: `${planDetails.ENERGYCHARGE.toFixed(2)} ¢/kWh`,
        rates: {
          "500kWh": planDetails.kWh500,
          "1000kWh": planDetails.kWh1000,
          "2000kWh": planDetails.kWh2000,
        },
        etf: `${planDetails.ETF} /mo`,
        baseCharge: planDetails.BASECHARGE,
      });
    } else {
      console.error(`Plan details for '${selectedPlan1}' not found.`);
    }
  }, [selectedPlan1]);

  React.useEffect(() => {
    if (selectedProvider0.length === 0 || !selectedProvider2 || !selectedPlan2)
      return;
    let plan = planb.response[selectedProvider0].find(
      (plan) =>
        plan.plan_name === selectedProvider2 &&
        plan.contract_term === selectedPlan2
    );
    // console.log("plan", plan);
    if (!plan) return;
    setPlan2({
      ...DefaultPlan,
      details: "Plan B",
      name: plan.plan_name,
      rates: {
        "500kWh": plan.price500,
        "1000kWh": plan.price1000,
        "2000kWh": plan.price2000,
      },

      // this is for Dynamic ETF from Plan B API
      etf: `${plan.cancel_fee} /mo`,

      baseCharge: plan.base_fee1,
    });
  }, [selectedPlan2, selectedProvider0, selectedProvider2]);

  return (
    <FlexContainer>
      <PlanContainer>
        <p
          style={{
            fontFamily: "Futura PT Book",
            letterSpacing: "2px",
            fontWeight: "bold",
          }}
        >
          PLAN A
        </p>
        <Box mb={5}>
          <Dropdown
            selectedValue={selectedPlan0}
            title="SELECT PROVIDER"
            menuItems={planMenuItems0}
            onChange={handlePlan0Change}
          />
        </Box>
        <Box mb={5}>
          <Dropdown
            selectedValue={selectedProvider1}
            title="SELECT PLAN"
            menuItems={planMenuItems3}
            onChange={handleProvider1Change}
          />
        </Box>

        <Box mb={5}>
          <Dropdown
            selectedValue={selectedPlan1}
            title="TERMS"
            menuItems={planMenuItems1}
            onChange={handlePlan1Change}
          />
        </Box>
      </PlanContainer>

      <PlanTitle sx={{ textAlign: "center", fontFamily: "Futura PT Book" }}>
        VS
      </PlanTitle>

      <PlanContainer>
        <p
          style={{
            fontFamily: "Futura PT Book",
            letterSpacing: "2px",
            fontWeight: "bold",
          }}
        >
          PLAN B
        </p>
        <Box mb={5}>
          <Dropdown
            selectedValue={selectedProvider0}
            title="SELECT PROVIDER"
            menuItems={providerMenuItems0}
            onChange={handleProvider0Change}
          />
        </Box>
        <Box mb={5}>
          <Dropdown
            selectedValue={selectedProvider2}
            title="SELECT PLAN"
            menuItems={providerMenuItems2}
            onChange={handleProvider2Change}
          />
        </Box>
        <Box mb={5}>
          <Dropdown
            selectedValue={selectedPlan2}
            title="TERMS"
            menuItems={planMenuItems2}
            onChange={handlePlan2Change}
          />
        </Box>
      </PlanContainer>
    </FlexContainer>
  );
};

export default GraphHeader;
